export default {
  // 登录信息
  USERINFO: (state, data) => {
    state.userInfo = data;
    localStorage.setItem('userInfo', JSON.stringify(data || {}));
  },
  TIMEZONEID: (state, data) => {
    state.timeZoneId = data;
    localStorage.setItem('timeZoneId', data);
  },
  TIMEZONECOUNT: (state, data) => {
    state.timeZoneCount = data;
    localStorage.setItem('timeZoneCount', data);
  },
  DATEFORMAT: (state, data) => {
    state.dateFormat = data;
    localStorage.setItem('dateFormat', data);
  },
  ISTIME24H: (state, data) => {
    state.isTime24h = `${data}`;
    localStorage.setItem('isTime24h', `${data}`);
  },
  PSWDLOGINCHANGE: (state, data) => {
    state.pswdLoginChange = `${data}`;
    localStorage.setItem('pswdLoginChange', `${data}`);
  },
  TIMEZONESHORT: (state, data) => {
    state.timeZoneShort = data;
    localStorage.setItem('timeZoneShort', data);
  },
  // 退出
  LOGINOUT: (state) => {
    state.userInfo = {};
    state.menuRecord = {};
    localStorage.removeItem('userInfo');
    localStorage.removeItem('timeZoneId');
    localStorage.removeItem('menuRoleBoList');
  },
  // 按钮权限
  MENUOBJ: (state, data) => {
    state.menuObj = data;
  },
  // 字典
  DICTIONARY: (state, data) => {
    state.dictionary = data;
  },
  // 功能
  FUNCVIEW: (state, data) => {
    state.funcView = data;
  },
  // 多语言
  LANGUAGE: (state, data) => {
    state.language = data;
  },
  // 主题颜色
  THEMECOLOR: (state, data) => {
    state.themeColor = data;
    localStorage.themeColor = data;
  },
  // WebSocket消息条数
  MESSAGEWS: (state, data = 0) => {
    state.messageNum = data;
  },
  // 菜单appid
  APP_ID: (state, val) => {
    state.appId = val;
  },
  // 菜单数据缓存
  MENU_RECORD: (state, val) => {
    state.menuRecord = val;
  },
  // menuRoleBoList
  MENU_ROLE_BO_LIST: (state, val) => {
    state.menuRoleBoList = val;
    localStorage.setItem('menuRoleBoList', JSON.stringify(val || []));
  },
};
